<template>
  <Photos year="2026" :min-date="1776124800" :max-date="1776384000" date-text="April 14&ndash;17" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
